import api from '@/config/api'
import vuex from '@/store'
import catchErrors from './catchErrors'

// const headers = {
//     'x-rapidapi-host': 'vanitysoft-boundaries-io-v1.p.rapidapi.com',
//     'x-rapidapi-key': 'secret'
// }

export default {
  getUserPreferences(emp_id) {
    const station = vuex.getters.currentStation.station
    if (!station) return
    return catchErrors.get(`/v2/newsdesk/${station}/${emp_id}/preferences/user`, {
      cache: {
        maxAge: 120 * 1000,
        ignoreCache: true
      }
    })
  },
  createUserPreferences(emp_id, data) {
    const station = vuex.getters.currentStation.station
    if (!station) return
    return catchErrors.post(`/v2/newsdesk/${station}/${emp_id}/preferences/user`, data)
  },
  updateUserPreferences(emp_id, key, data) {
    if (data == null) throw new Error('Data cannot be null')
    const wrappedData = {
      value: data
    }
    const station = vuex.getters.currentStation.station
    if (!station) return
    return catchErrors.patch(`/v2/newsdesk/${station}/${emp_id}/preferences/user/${key}`, wrappedData)
  },
  deleteUserPreferences(emp_id, key) {
    const station = vuex.getters.currentStation.station
    if (!station) return
    return catchErrors.delete(`/v2/newsdesk/${station}/${emp_id}/preferences/user/${key ?? ''}`)
  },
  getStationPreferences() {
    const station = vuex.getters.currentStation.station
    if (!station) return
    return catchErrors.get(`/v2/newsdesk/${station}/${station}/preferences/station`, {
      cache: {
        maxAge: 120 * 1000,
        ignoreCache: true
      }
    })
  },
  createStationPreferences(data) {
    const station = vuex.getters.currentStation.station
    if (!station) return
    return catchErrors.post(`/v2/newsdesk/${station}/${station}/preferences/station`, data)
  },
  updateStationPreferences(key, data) {
    if (data == null) throw new Error('Data cannot be null')
    const wrappedData = {
      value: data
    }
    const station = vuex.getters.currentStation.station
    if (!station) throw new Error('Station cannot be null')
    return catchErrors.patch(`/v2/newsdesk/${station}/${station}/preferences/station/${key}`, wrappedData)
  },
  deleteStationPreferences(key) {
    const station = vuex.getters.currentStation.station
    if (!station) return
    return catchErrors.delete(`/v2/newsdesk/${station}/${station}/preferences/station/${key ?? ''}`)
  }
}
